import { render } from "./MarketplaceValue.vue?vue&type=template&id=54a37985&scoped=true"
import script from "./MarketplaceValue.vue?vue&type=script&lang=js"
export * from "./MarketplaceValue.vue?vue&type=script&lang=js"

import "./MarketplaceValue.vue?vue&type=style&index=0&id=54a37985&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a37985"]])

export default __exports__